/* eslint-disable @typescript-eslint/no-unused-vars */
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '../../../../lib/utils';
import { Input, Typography } from '../../atoms';

// ----------------------------------------------------------------------

type Props = {
  name: string;
  id?: string;
  haneldErrorMsg?: React.Dispatch<React.SetStateAction<string>>;
  helperText?: React.ReactNode;
  type?: 'text' | 'password' | 'email' | 'number' | 'tel' | 'url';
  label?: string;
  className?: string;
  placeholder?: string;
  onKeyDown?: any;
  variant?: 'filled' | 'outlined' | 'standard';
  disabled?: boolean;
  onFocus?: any;
  error?: any;
  value?: string | number;
  onChange?: any;
  rules?: any;
  min?: number;
  negative?: boolean;
};

export const RHFInput = ({
  haneldErrorMsg,
  name,
  id,
  helperText,
  type,
  label,
  className,
  placeholder,
  variant,
  disabled,
  onFocus,
  onKeyDown,
  onChange,
  error: errorProp,
  min,
  rules,
  negative = true,

  ...other
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const computedError = error?.message || errorProp;

        return (
          <div>
            <Input
              {...field}
              id={id}
              className={cn(className, {
                'border-red-300 text-red-500 placeholder:text-red-500':
                  computedError
              })}
              min={min}
              onFocus={onFocus}
              disabled={disabled}
              placeholder={label ?? placeholder}
              onKeyDown={e => {
                if (e.key === '-' && !negative) {
                  e.preventDefault();
                }
              }}
              type={type}
              value={field.value}
              onChange={event => {
                if (onChange) onChange(event.target.value);
                if (type === 'number') {
                  const value = event.target.value;
                  field.onChange(value === '' ? '' : Number(value));
                } else {
                  field.onChange(event.target.value);
                }
                if (haneldErrorMsg) {
                  haneldErrorMsg('');
                }
              }}
              {...other}
            />
            <Typography variant='body2' className='text-red-500 mt-2'>
              {computedError?.message ?? error?.message ?? ''}
            </Typography>
          </div>
        );
      }}
    />
  );
};
